export default __webpack_public_path__ + "static/media/app-deploy.2acd1f10.svg";